<template>
    <div id="novice">
        <el-card class="box-card">
            <el-table :data="tableData" border style="width: 100%">
                <el-table-column type="index" label="#"></el-table-column>

              <el-table-column
                        prop="title"
                        label="标题">
                </el-table-column>

                <el-table-column
                        prop="sub_title"
                        label="类容">
                </el-table-column>

                 <el-table-column
                        prop="target"
                        label="任务次数">
                </el-table-column>


                <el-table-column
                        prop="coin"
                        label="赠送奖励">
                </el-table-column> 

                 <el-table-column
                        prop="status"
                        label="显示/不显示">
                </el-table-column> 

                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button type="primary" plain size="small" @click="edit(scope.$index)">编辑</el-button>
                        <!--<el-button type="danger" plain size="small" @click="getareaDelete(scope.$index)">删除</el-button> -->
                    </template>
                </el-table-column>
            </el-table>
        </el-card>
        <!--        添加区域对话框-->
        <el-dialog 
                :title="title" 
                :visible.sync="dialogVisible" 
                :width="this.$store.state.dialogWidth">
            <el-form ref="loginForm" status-icon :model="form" :label-width="this.$store.state.labelWidth" size="small">
                <el-form-item label="标题" prop="title">
                    <el-input v-model="form.title" v-bind:disabled="disabled"></el-input>
                </el-form-item>

                <el-form-item label="类容" prop="sub_title">
                    <el-input v-model="form.sub_title"></el-input>
                </el-form-item>

                <el-form-item label="任务次数" prop="target">
                    <el-input v-model="form.target" ></el-input>
                </el-form-item>

                <el-form-item label="赠送奖励" prop="coin">
                    <el-input v-model="form.coin"></el-input>
                </el-form-item>

                <el-form-item label="是否显示" prop="status">
                    <el-input v-model="form.status" ></el-input>
                </el-form-item>
               
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false" size="small">取 消</el-button>
                <el-button type="primary" @click="ReleaseClick" size="small">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "novice",
        data() {
            return {
                form: {
                    title: '',
                    sub_title: '',
                    target:'',
                    coin: '',
                    status:'',

                },
                classUpdate: {},
                dialogVisible: false, //添加区域对话框
                tableData: [],
                list: [],
                index: '',
                title:'编辑',
                disabled:false,
            }
        },
        created() {
            this.getclassList();
        },
        methods: {
            getclassList() {
                this.$axios.post("admin/config/daily",).then(res => {
                    let obj = res.data;
                    let arr = [];
                    this.list = [];
                    for (let key in obj) {
                        arr.push({
                            title: obj[key]['title'],
                            sub_title: obj[key]['sub_title'],
                            target: obj[key]['target'],
                            coin: obj[key]['coin'],
                            status: obj[key]['status']
                        });
                        this.list.push(obj[key]);
                    }
                    this.tableData = arr;
                })
            },
            edit(index) {
                this.title = '编辑'
                this.form.title = this.tableData[index].title;
                this.form.sub_title = this.tableData[index].sub_title;
                this.form.target = this.tableData[index].target;
                this.form.coin  = this.tableData[index].coin;
                this.form.status  = this.tableData[index].status;
                this.index = index;
                this.dialogVisible = true;
            },
            // 确定按钮
            ReleaseClick() {

            },
        }
    }
</script>

<style scoped>

</style>